import connection from '../../utils/api';
import { handleNotifications } from '../../utils/notifications';
import { hideLoading, showLoading } from './ui';

export const addNews = (payload, cb) => dispatch => {
  dispatch(showLoading());
  return connection.post('/industry_news', payload)
    .then(({ data }) => {
      if(data.success){
        handleNotifications('success', "Success", data.message);
        cb && cb();
      } else {
        handleNotifications('error', 'Failed', data.message);
      }
    })
    .catch(error => {
      handleNotifications('error', 'Failed', error.message);
    });
};

export const getNews = () => dispatch => {
  dispatch(showLoading());
  return connection.get('/industry_news')
    .then(({ data }) => {
      dispatch(hideLoading());
      if(data.success){
         //handleNotifications('success', "Success", data.message);
        return data.data
      } else {
        handleNotifications('error', 'Failed', data.message);
        return [];
      }
    })
    .catch(error => {
      dispatch(hideLoading());
      handleNotifications('error', 'Failed', error.message);
    });
};

export const updateNews = (id, payload, cb) => dispatch => {
  dispatch(showLoading());
  connection.put(`/industry_news/${id}`, payload)
    .then(({ data }) => {
      if(data.success){
        handleNotifications('success', "Success", data.message);
        cb && cb();
      } else {
        handleNotifications('error', 'Failed', data.message);
      }
      dispatch(hideLoading());
    })
    .catch(error => {
      dispatch(hideLoading());
      handleNotifications('error', 'Failed', error.message);
    });
};

export const deleteNews = (id) => dispatch => {
  return connection.delete(`/industry_news/${id}`)
    .then(({ data }) => {
      if(data.success){
        handleNotifications('success', "Success", data.message);
      } else {
        handleNotifications('error', 'Failed', data.message);
      }
    })
    .catch(error => {
      handleNotifications('error', 'Failed', error.message);
    });
};
